/* 2026-11-03: upload product enquiry media and send the full inquiry to Longshade's website backend. */
'use strict';
(() => {
  if (window.__lsProductInquiryUploadInitialized) return;
  window.__lsProductInquiryUploadInitialized = true;

  const API = 'https://api.sifanonline.com/api/coollaa';
  const SITE = 'longshade.sg';
  const MAX_FILES = 5;
  const MAX_FILE_BYTES = 8 * 1024 * 1024;
  const ALLOWED_MEDIA = {
    jpg: { kind: 'image', mimeType: 'image/jpeg' },
    jpeg: { kind: 'image', mimeType: 'image/jpeg' },
    png: { kind: 'image', mimeType: 'image/png' },
    webp: { kind: 'image', mimeType: 'image/webp' },
    mp4: { kind: 'video', mimeType: 'video/mp4' },
    webm: { kind: 'video', mimeType: 'video/webm' },
    mov: { kind: 'video', mimeType: 'video/quicktime' }
  };
  const productNames = {
    'ls-100-zip-blind': 'LS-100 Zip Blind',
    'ls-120-zip-blind': 'LS-120 Zip Blind',
    'ls-120-140-zip-blind': 'LS-120-140 Zip Blind',
    'ls-130-180-zip-blind': 'LS-130-180 Zip Blind',
    'ls-135-150-zip-blind': 'LS-135-150 Zip Blind',
    's156-mid-size-motorised-pergola': 'S156 Mid-Size Motorised Pergola',
    's200-heavy-duty-motorised-pergola': 'S200 Heavy-Duty Motorised Pergola',
    'm156-minimalist-manual-pergola': 'M156 Minimalist Manual Pergola',
    'made-to-measure-pergola': 'Made-to-Measure Pergola',
    'aluminium-canopy-series-101': 'Aluminium Canopy Series 101',
    'aluminium-canopy-series-102': 'Aluminium Canopy Series 102',
    'aluminium-canopy-series-103': 'Aluminium Canopy Series 103'
  };
  const formTypes = {
    zip: 'zip_blinds_config',
    pergola: 'pergola_config',
    canopy: 'canopy_enquiry'
  };
  const pageHandle = decodeURIComponent(location.pathname.split('/').filter(Boolean).pop() || '');
  const productName = productNames[pageHandle];
  if (!productName) return;

  const isZip = pageHandle.includes('zip-blind');
  const isPergola = pageHandle.includes('pergola');
  const formType = isZip ? formTypes.zip : isPergola ? formTypes.pergola : formTypes.canopy;
  const configurationForm = isZip || isPergola ? document.querySelector('#shade-form') : null;
  const contactForm = isZip
    ? document.querySelector('#LS100Contact, #LSZipContact, #shade-form')
    : isPergola
      ? document.querySelector('#PergolaContact, #shade-form')
      : document.querySelector('form.ls-canopy-detail__form, form[id^="CanopyEnquiry"]');
  if (!contactForm) return;
  if (contactForm.dataset.lsInquiryUploadBound === 'true') return;
  contactForm.dataset.lsInquiryUploadBound = 'true';

  const files = [];
  const objectUrls = new Map();
  let submitting = false;
  const widget = createUploadWidget();
  mountUploadWidget(widget);
  const feedback = document.createElement('p');
  feedback.className = 'ls-inquiry-feedback';
  feedback.hidden = true;
  feedback.setAttribute('role', 'status');
  feedback.setAttribute('aria-live', 'polite');
  feedback.tabIndex = -1;
  const feedbackAnchor = contactForm.querySelector('.ls100-dialog-actions, .ls-pergola-dialog-actions, .ls-canopy-detail__actions');
  if (feedbackAnchor) contactForm.insertBefore(feedback, feedbackAnchor);
  else contactForm.prepend(feedback);
  const successDialog = createSuccessDialog();

  function startSubmission(submitter) {
    if (submitting || contactForm.dataset.inquirySent === 'true') return;
    submitInquiry(submitter).catch(error => {
      setFeedback(error instanceof Error ? error.message : 'We could not send your enquiry. Please try again.', 'error');
      submitting = false;
      setSubmitDisabled(false);
    });
  }

  contactForm.addEventListener('submit', event => {
    event.preventDefault();
    event.stopImmediatePropagation();
    startSubmission(event.submitter);
  }, true);
  const sendButton = contactForm.querySelector('[data-ls-inquiry-submit]');
  if (sendButton) {
    sendButton.addEventListener('click', event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      startSubmission(sendButton);
    }, true);
  }

  function createUploadWidget() {
    const root = document.createElement('div');
    root.className = 'ls-inquiry-upload-field';
    root.dataset.lsInquiryUpload = 'true';

    const label = document.createElement('label');
    label.className = 'ls-inquiry-upload-label';
    label.textContent = 'Upload photos, plans or videos';
    const optional = document.createElement('small');
    optional.textContent = 'Optional';
    label.append(optional);

    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.jpg,.jpeg,.png,.webp,.mp4,.webm,.mov,image/jpeg,image/png,image/webp,video/mp4,video/webm,video/quicktime';
    input.multiple = true;
    input.hidden = true;
    input.id = 'ls-inquiry-upload-' + Math.random().toString(36).slice(2, 9);
    input.setAttribute('aria-label', 'Choose image or video files');
    label.htmlFor = input.id;

    const controls = document.createElement('div');
    controls.className = 'ls-inquiry-upload-control';
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ls-inquiry-upload-button';
    button.innerHTML = '<svg class="ls-inquiry-upload-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 16V4m0 0L7.5 8.5M12 4l4.5 4.5M5 14v5h14v-5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Choose files</span>';
    button.addEventListener('click', () => input.click());
    input.addEventListener('change', () => {
      addFiles(Array.from(input.files || []));
      input.value = '';
    });
    controls.append(button, input);

    const hint = document.createElement('p');
    hint.className = 'ls-inquiry-upload-hint';
    hint.textContent = 'JPG, PNG or WebP images; MP4, WebM or MOV videos. Up to 5 files, 8 MB each.';
    const list = document.createElement('div');
    list.className = 'ls-inquiry-upload-list';
    list.setAttribute('aria-live', 'polite');
    root.append(label, controls, hint, list);
    root._list = list;
    root._button = button;
    root._hint = hint;
    return root;
  }

  function mountUploadWidget(root) {
    const mount = document.querySelector('[data-ls-inquiry-upload-slot]');
    if (mount) {
      mount.replaceWith(root);
      return;
    }

    const oldInput = contactForm.querySelector('#photo_link, [name="photo_link"]') || document.querySelector('#photo_link, [name="photo_link"]');
    if (oldInput) {
      const field = oldInput.closest('.ls-field') || oldInput.closest('.field') || oldInput.parentElement;
      if (field) field.replaceWith(root);
      else oldInput.replaceWith(root);
      return;
    }

    if (isZip || isPergola || formType === formTypes.canopy) {
      const submit = contactForm.querySelector('button[type="submit"]');
      const field = document.createElement('div');
      field.className = 'ls-inquiry-upload-form-field';
      field.append(root);
      const anchor = contactForm.querySelector('.ls-pergola-dialog-actions, .ls-canopy-detail__actions') || submit;
      if (anchor?.parentElement) anchor.parentElement.insertBefore(field, anchor);
      else contactForm.append(field);
    }
  }

  function addFiles(selected) {
    for (const file of selected) {
      const extension = file.name.split('.').pop().toLowerCase();
      const media = ALLOWED_MEDIA[extension];
      if (!media || (file.type && file.type !== media.mimeType)) {
        setFeedback(file.name + ': choose JPG, PNG, WebP, MP4, WebM or MOV files.', 'error');
        continue;
      }
      if (file.size > MAX_FILE_BYTES) {
        setFeedback(file.name + ': each file must be 8 MB or smaller.', 'error');
        continue;
      }
      if (files.length >= MAX_FILES) {
        setFeedback('You can attach up to 5 files.', 'error');
        break;
      }
      if (files.some(existing => existing.name === file.name && existing.size === file.size && existing.lastModified === file.lastModified)) continue;
      files.push(file);
    }
    renderFiles();
    if (files.length && feedback.classList.contains('is-error')) setFeedback('', '');
  }

  function renderFiles() {
    widget._list.replaceChildren();
    files.forEach((file, index) => {
      const item = document.createElement('div');
      item.className = 'ls-inquiry-upload-item';
      const media = ALLOWED_MEDIA[file.name.split('.').pop().toLowerCase()];
      const preview = document.createElement(media.kind === 'video' ? 'video' : 'img');
      preview.className = 'ls-inquiry-upload-thumb';
      if (media.kind === 'video') {
        preview.controls = true;
        preview.muted = true;
        preview.playsInline = true;
        preview.preload = 'metadata';
        preview.setAttribute('aria-label', 'Preview ' + file.name);
      } else {
        preview.alt = '';
      }
      let objectUrl = objectUrls.get(file);
      if (!objectUrl) {
        objectUrl = URL.createObjectURL(file);
        objectUrls.set(file, objectUrl);
      }
      preview.src = objectUrl;
      const name = document.createElement('span');
      name.className = 'ls-inquiry-upload-filename';
      name.textContent = file.name + ' · ' + (file.size / 1024 / 1024).toFixed(1) + ' MB';
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'ls-inquiry-file-remove';
      remove.textContent = '×';
      remove.setAttribute('aria-label', `Remove ${file.name}`);
      remove.addEventListener('click', () => {
        const removed = files.splice(index, 1)[0];
        const url = objectUrls.get(removed);
        if (url) URL.revokeObjectURL(url);
        objectUrls.delete(removed);
        renderFiles();
        setFeedback('', '');
      });
      item.append(preview, name, remove);
      widget._list.append(item);
    });
  }

  function readFormFields(form) {
    const result = {};
    if (!form) return result;
    for (const [rawKey, value] of new FormData(form).entries()) {
      if (value instanceof File || ['form_type', 'utf8', 'authenticity_token'].includes(rawKey)) continue;
      const match = rawKey.match(/^contact\[(.+)\]$/);
      const key = match ? match[1] : rawKey;
      if (!String(value).trim() && key !== 'Configuration') continue;
      if (Object.prototype.hasOwnProperty.call(result, key)) {
        result[key] = Array.isArray(result[key]) ? [...result[key], value] : [result[key], value];
      } else result[key] = value;
    }
    return result;
  }

  function readConfigurationSnapshot() {
    if (pageHandle !== 'ls-100-zip-blind' || !configurationForm) return null;
    try {
      const data = JSON.parse(configurationForm.dataset.lsInquiryConfiguration || 'null');
      return data && typeof data === 'object' && !Array.isArray(data) ? data : null;
    } catch (_) {
      return null;
    }
  }

  function ls100Summary(data) {
    if (!data) return '';
    const openings = Array.isArray(data.openings) && data.openings.length
      ? data.openings.map((opening, index) => `${opening.label || `Opening ${index + 1}`}: ${opening.width_mm || '—'} × ${opening.height_mm || '—'} mm${opening.needs_assessment ? ' (team assessment requested)' : ''}`).join('\n')
      : data.measurement_status === 'home_measurement' ? 'Home measurement requested' : 'No opening sizes supplied';
    const rows = [
      ['Product', data.product],
      ['Space type', data.space_type],
      ['Exposure', data.exposure],
      ['Layout', data.layout],
      ['Measurement status', data.measurement_status],
      ['Opening sizes', openings],
      ['Identical sets', data.identical_sets],
      ['Main priority', data.shade_priority],
      ['Fabric collection', data.fabric_id],
      ['Fabric openness', data.fabric_openness == null ? '' : `${data.fabric_openness}%`],
      ['Fabric colour', data.fabric_colour_id],
      ['Frame colour', data.frame_colour],
      ['Special finish request', data.custom_finish_request],
      ['Operation', data.operation],
      ['Control preference', data.control_preference],
      ['App control interest', data.app_control_interest],
      ['Rain sensor interest', data.rain_sensor_interest],
      ['Full name', data.customer_name],
      ['Phone / WhatsApp', data.phone],
      ['Email', data.email],
      ['Postal code', data.postal_code],
      ['Project name', data.project_name],
      ['Customer notes', data.customer_notes]
    ];
    return rows.filter(([, value]) => value !== '' && value != null).map(([label, value]) => `${label}: ${value}`).join('\n');
  }

  function ls100Brief(data) {
    if (!data) return '';
    const openings = Array.isArray(data.openings) && data.openings.length
      ? data.openings.map(opening => `${opening.width_mm || '—'} × ${opening.height_mm || '—'} mm`).join(', ')
      : data.measurement_status === 'home_measurement' ? 'home measurement requested' : 'sizes to be confirmed';
    return [
      data.product || productName,
      [data.space_type, data.exposure].filter(Boolean).join(' · '),
      data.layout,
      openings,
      data.identical_sets ? `${data.identical_sets} set(s)` : '',
      data.shade_priority,
      data.fabric_colour_id || data.fabric_id,
      data.frame_colour,
      data.operation,
      data.customer_notes
    ].filter(Boolean).join(' · ');
  }

  async function uploadFile(file) {
    const data = new FormData();
    data.append('file', file, file.name);
      const response = await fetch(`${API}/inquiry-upload?site=${encodeURIComponent(SITE)}`, {
      method: 'POST',
      body: data,
      mode: 'cors',
      credentials: 'omit'
    });
    const body = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(body.error || 'Media upload failed (' + response.status + ').');
    return {
      fileName: body.fileName || file.name,
      fileUrl: body.fileUrl || body.url || '',
      fileKey: body.fileKey || '',
      mimeType: body.mimeType || file.type || '',
      fileSize: body.fileSize || file.size
    };
  }

  async function submitInquiry(submitter) {
    if (submitting) return;
    submitting = true;
    setSubmitDisabled(true);
    setFeedback(files.length ? 'Uploading your files…' : 'Sending your enquiry…', '');

    const uploaded = [];
    for (const file of files) {
      uploaded.push(await uploadFile(file));
      setFeedback('Uploaded ' + uploaded.length + ' of ' + files.length + ' files…', '');
    }

    const submittedFields = readFormFields(contactForm);
    const configurationSnapshot = readConfigurationSnapshot();
    let configurationFields = configurationSnapshot ? { ...configurationSnapshot } : (configurationForm && configurationForm !== contactForm
      ? readFormFields(configurationForm)
      : {});
    if (configurationSnapshot) {
      submittedFields.name = submittedFields.name || configurationSnapshot.customer_name || '';
      submittedFields.email = submittedFields.email || configurationSnapshot.email || '';
      submittedFields.phone = submittedFields.phone || configurationSnapshot.phone || '';
      if (configurationSnapshot.customer_notes) submittedFields.Message = configurationSnapshot.customer_notes;
      delete configurationFields.customer_name;
      delete configurationFields.email;
      delete configurationFields.phone;
    }
    const summaryText = ls100Summary(configurationSnapshot) || submittedFields.Configuration || configurationFields.Configuration || '';
    delete submittedFields.Configuration;
    delete submittedFields['Product URL'];
    delete configurationFields.Configuration;
    delete configurationFields['Product URL'];
    delete configurationFields.photo_link;
    const payload = {
      productName: configurationSnapshot?.product || submittedFields.Product || productName,
      productConfiguration: {
        summaryText,
        submittedFields,
        configurationFields
      },
      attachments: uploaded
    };
    const scalarValue = value => Array.isArray(value) ? (value.find(item => String(item).trim()) || '') : (value || '');
    const inquiry = {
      formType,
      pageUrl: location.href,
      pageHandle,
      productHandle: pageHandle,
      name: scalarValue(configurationSnapshot?.customer_name) || scalarValue(submittedFields.name) || scalarValue(submittedFields.Name) || scalarValue(submittedFields.customer_name),
      email: scalarValue(configurationSnapshot?.email) || scalarValue(submittedFields.email) || scalarValue(submittedFields.Email),
      phone: scalarValue(configurationSnapshot?.phone) || scalarValue(submittedFields.phone) || scalarValue(submittedFields.Phone),
      postalCode: scalarValue(configurationSnapshot?.postal_code) || scalarValue(submittedFields['Postal code']) || scalarValue(submittedFields['Project location']) || scalarValue(submittedFields.postal_code) || scalarValue(configurationFields.postal_code),
      message: scalarValue(configurationSnapshot?.customer_notes) || scalarValue(submittedFields.body) || scalarValue(submittedFields.Message) || scalarValue(submittedFields.customer_notes) || ls100Brief(configurationSnapshot),
      payload,
      isTest: false
    };
    const response = await fetch(`${API}/inquiry?site=${encodeURIComponent(SITE)}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(inquiry),
      mode: 'cors',
      credentials: 'omit'
    });
    const body = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(body.error || `We could not send your enquiry (${response.status}). Please try again.`);

    contactForm.dataset.inquirySent = 'true';
    if (submitter) submitter.textContent = 'Enquiry sent';
    setSubmitDisabled(true);
    const reviewButton = document.querySelector('#quote-button');
    if (reviewButton) {
      reviewButton.textContent = 'Enquiry sent';
      reviewButton.disabled = true;
    }
    const dialog = contactForm.closest('dialog');
    const dialogTitleId = dialog?.getAttribute('aria-labelledby');
    const dialogTitle = dialogTitleId ? document.getElementById(dialogTitleId) : null;
    if (dialogTitle) dialogTitle.textContent = 'Your enquiry has been received';
    setFeedback('Thank you. Your enquiry and files have been sent to our Singapore team.', 'success');
    files.length = 0;
    renderFiles();
    if (dialog?.open) dialog.close();
    showSuccessDialog();
  }

  function setSubmitDisabled(disabled) {
    contactForm.querySelectorAll('button[type="submit"], [data-ls-inquiry-submit]').forEach(button => { button.disabled = disabled; });
    widget._button.disabled = disabled;
  }

  function setFeedback(message, kind) {
    feedback.textContent = message;
    feedback.hidden = !message;
    feedback.classList.toggle('is-error', kind === 'error');
    feedback.classList.toggle('is-success', kind === 'success');
    feedback.setAttribute('role', kind === 'error' ? 'alert' : 'status');
    if (message && (kind === 'success' || kind === 'error')) {
      const parentDialog = feedback.closest('dialog');
      if (!parentDialog || parentDialog.open) {
        feedback.focus({ preventScroll: true });
        feedback.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  }

  function createSuccessDialog() {
    const dialog = document.createElement('dialog');
    dialog.className = 'ls-inquiry-success-dialog';
    dialog.setAttribute('aria-labelledby', 'ls-inquiry-success-title');

    const card = document.createElement('div');
    card.className = 'ls-inquiry-success-card';
    const icon = document.createElement('span');
    icon.className = 'ls-inquiry-success-icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '✓';
    const title = document.createElement('h2');
    title.id = 'ls-inquiry-success-title';
    title.textContent = 'Enquiry sent successfully';
    const message = document.createElement('p');
    message.textContent = 'Your enquiry and any attached files have been sent to our Singapore team. We’ll be in touch soon.';
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'ls-inquiry-success-close';
    close.textContent = 'Done';
    close.addEventListener('click', () => dialog.close());

    card.append(icon, title, message, close);
    dialog.append(card);
    dialog.addEventListener('click', event => {
      if (event.target === dialog) dialog.close();
    });
    document.body.append(dialog);
    return dialog;
  }

  function showSuccessDialog() {
    if (typeof successDialog.showModal === 'function') {
      if (!successDialog.open) successDialog.showModal();
      successDialog.querySelector('.ls-inquiry-success-close').focus();
    } else {
      window.alert('Enquiry sent successfully. Your enquiry and any attached files have been sent to our Singapore team. We’ll be in touch soon.');
    }
  }
})();
